import * as React from "react";
import * as ReactDOM from "react-dom";

import * as SDK_Shim from "VSS/SDK/Shim";
import AdminBuildAndReleaseHub = require("Build/Scripts/AdminBuildAndRelease/Components/AdminBuildAndReleaseHub");

import "Admin/Scripts/TFS.Admin.Security";
import "Build/Scripts/Controls.Admin";
import "Build/Scripts/AdminView"
import "Build/Scripts/KnockoutExtensions";

import "VSS/LoaderPlugins/Css!Build/FilterPanel";
import "VSS/LoaderPlugins/Css!BuildStyles";
import "VSS/LoaderPlugins/Css!VSS.Controls";

SDK_Shim.registerContent("buildQueueView.initialize", (context: SDK_Shim.InternalContentContextData): IDisposable => {
    AdminBuildAndReleaseHub.load(context.container);

    const disposable = {
        dispose: () => {
            ReactDOM.unmountComponentAtNode(context.container);
        }
    };

    return disposable;
});